import React from "react";

const NotificationPanel = ({ isOpen, onClose }) => {
  const notifications = [
    {
      id: 1,
      title: "Announcement",
      message:
        "We're thrilled to announce the launch of our new bond, designed to provide",
      time: "New",
    },
    {
      id: 2,
      title: "Announcement",
      message:
        "We're thrilled to announce the launch of our new bond, designed to provide",
      time: "2 day ago",
    },
    // Add more notifications as needed
  ];

  if (!isOpen) return null;

  return (
    <div className="fixed sm:absolute right-0 sm:mt-16 w-auto mx-4 sm:w-80 bg-white rounded-lg shadow-lg overflow-hidden max-h-[90vh] sm:max-h-[600px] top-[60px] sm:top-auto">
      {/* Header */}
      <div className="flex justify-between items-center p-4 border-b sticky top-0 bg-white">
        <h3 className="text-lg font-semibold text-[#0066b2]">Notification</h3>
        <button onClick={onClose} className="text-red-500 hover:text-red-700">
          Clear
        </button>
      </div>

      {/* Notification List */}
      <div className="overflow-y-auto max-h-[calc(90vh-60px)] sm:max-h-96">
        {notifications.map((notification) => (
          <div key={notification.id} className="border-b p-4 hover:bg-gray-50">
            <div className="flex justify-between items-start">
              <h4 className="text-[#0066b2] font-semibold">
                {notification.title}
              </h4>
              <span
                className={`text-sm ${
                  notification.time === "New"
                    ? "bg-[#0066b2] text-white px-2 py-1 rounded"
                    : "text-gray-500"
                }`}
              >
                {notification.time}
              </span>
            </div>
            <p className="text-gray-600 mt-1">{notification.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationPanel;
